import GigyaResponse from './interfaces/gigya-response.js'

export * from './interfaces/gigya-response.js'

export class GigyaError extends Error {
	public readonly gigyaResponse: GigyaResponse
	public readonly errorCode: number
	public readonly params: any

	constructor(message: string, gigyaResponse: GigyaResponse, errorCode: number, params: any) {
		super(message)
		this.gigyaResponse = gigyaResponse
		this.errorCode = errorCode
		this.params = params
	}
}

export default GigyaError
